import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { COLORS } from "../../constants/colors";
import makeStyles from '@mui/styles/makeStyles';
import { useSelector } from "react-redux";
import { getShorthandSettings } from "../../model/slice/dateTimeShorthandSlice";
import { convertToTimezone, formatDate, getCurrentDateWithTimezone } from "../../util/timezone";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { IconButton } from "@mui/material";

const useStyles = makeStyles(() => ({
  base: {
    color: COLORS.white,
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  textContainer: {
    textAlign: "center",
    fontSize: "10px",
    margin: "0 4px",
    userSelect: "none",
  },
}));

const timeDirection = {
  ahead: "ahead",
  back: "back",
};

export const DateTimeDisplay = (props) => {
  const { date, submitDateTimeChange, latestDateTime, timezone } = props;
  const styles = useStyles();
  const shorthandValue = useSelector(getShorthandSettings);
  const [updateFlag, setUpdateFlag] = useState(false);
  const handleClick = (value, direction) => {
    if (handleDisabled(value, direction)) return;
    switch (direction) {
      case timeDirection.ahead:
        submitDateTimeChange(convertToTimezone(date, timezone).add(value, "m"));
        break;
      case timeDirection.back:
        submitDateTimeChange(convertToTimezone(date, timezone).subtract(value, "m"));
        break;
    }
  };

  const handleDisabled = (value, direction) => {
    switch (direction) {
      case timeDirection.ahead:
        if (convertToTimezone(date, timezone).add(value, "m").isAfter(convertToTimezone(latestDateTime, timezone))) return true;
        break;
      case timeDirection.back:
        if (convertToTimezone(date, timezone).subtract(value, "m").isBefore(getCurrentDateWithTimezone(timezone).subtract(30, "day")))
          return true;
        break;
    }
    return false;
  };

  //to update Icon state per 1min
  useEffect(() => {
    if (updateFlag === true) {
      setUpdateFlag(false);
      return;
    }
    setTimeout(() => {
      setUpdateFlag(true);
    }, 60 * 1000);
  }, [updateFlag]);

  return (
    <div className={styles.base}>
      <IconButton onClick={() => handleClick(shorthandValue.long, timeDirection.back)}>
        <KeyboardDoubleArrowLeftIcon sx={{fill: 'white', opacity: handleDisabled(shorthandValue.short, timeDirection.back, updateFlag) ? 0.5 : 1}}/>
      </IconButton>
      <IconButton onClick={() => handleClick(shorthandValue.short, timeDirection.back)}>
        <ChevronLeftIcon sx={{fill: 'white', opacity: handleDisabled(shorthandValue.short, timeDirection.back, updateFlag) ? 0.5 : 1}}/>
      </IconButton>
      <div className={styles.textContainer}>
        <span>{formatDate(date, timezone, "YYYY/MM/DD")}</span>
        <br />
        <span>{`${formatDate(date, timezone, "HH:mm")} (${timezone})`}</span>
      </div>
      <IconButton onClick={() => handleClick(shorthandValue.short, timeDirection.ahead)}>
        <ChevronRightIcon sx={{fill: 'white', opacity: handleDisabled(shorthandValue.short, timeDirection.ahead, updateFlag) ? 0.5 : 1}}/>
      </IconButton>
      <IconButton onClick={() => handleClick(shorthandValue.long, timeDirection.ahead)}>
        <KeyboardDoubleArrowRightIcon sx={{fill: 'white', opacity: handleDisabled(shorthandValue.long, timeDirection.ahead, updateFlag) ? 0.5 : 1}}/>
      </IconButton>
      </div>
  );
};

DateTimeDisplay.propTypes = {
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date), PropTypes.object]),
  submitDateTimeChange: PropTypes.func,
  time: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date), PropTypes.object]),
  latestDateTime: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date), PropTypes.object]),
  timezone: PropTypes.string,
};
